import './Footer.scss';

function Footer() {
  return (

    <div className="footer__container">
      <div className="international__section">
        <p className="footer__title"> Internacional </p>
        <ul>
          <li><a className="footer__item" title="United Kingdom" href="https://www.vinoseleccion.co.uk">United Kingdom</a></li>
          <li><a className="footer__item" title="Deutschland" href="https://www.vinoseleccion.de">Deutschland</a></li>
          <li><a className="footer__item" title="Netherlands" href="https://www.vinoseleccion.nl">Netherlands</a></li>
          <li><a className="footer__item" title="France" href="https://www.vinoseleccion.fr">France</a></li>
          <li><a className="footer__item" title="Peru" href="https://vinoseleccion.com.pe">Perú</a></li>
        </ul>
      </div>
      <div className="vinoseleccion__section">
        <p className="footer__title">Vinoselección</p>
        <ul>
          <li className="footer__item"><a title="Blog" href="https://www.vinoseleccion.com/blog">Blog</a></li>
          <li className="footer__item"><a title="Qué es Vinoselección" href="https://www.vinoseleccion.com/que-es-vinoseleccion">Qué es Vinoselección</a></li>
          <li className="footer__item"><a title="Saber de vinos" href="https://www.vinoseleccion.com/saber-de-vinos">Saber de vinos</a></li>
          <li className="footer__item"><a title="Condiciones de venta" href="https://www.vinoseleccion.com/condiciones-venta">Condiciones de venta</a></li>
          <li className="footer__item"><a title="Condiciones de transporte" href="https://www.vinoseleccion.com/condiciones-de-transporte">Condiciones de transporte</a></li>
          <li className="linksfooter"><a title="Ayuda" href="https://www.vinoseleccion.com/ayuda">Ayuda</a></li>
        </ul>
      </div>
      <div className="contact__section">
        <p className="footer__title">Contacto</p>
        <ul>
          <li>Guzman el Bueno, 133 28003 Madrid</li>
          <li><a className="footer__item" title="sociosvs@vinoseleccion.com" href="mailto:sociosvs@vinoseleccion.com">sociosvs@vinoseleccion.com</a></li>
          <li><a className="footer__item" href="tel:914539300">91 453 93 00</a></li>
          <li><a className="footer__item" href="tel:686100500">686 100 500</a></li>
        </ul>
      </div>
    </div>

  );
}

export default Footer;
